import { render } from "./MuteButton.vue?vue&type=template&id=496a49ee&scoped=true"
import script from "./MuteButton.vue?vue&type=script&lang=js"
export * from "./MuteButton.vue?vue&type=script&lang=js"

import "./MuteButton.vue?vue&type=style&index=0&id=496a49ee&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-496a49ee"]])

export default __exports__